import { propsTypes } from './sprite-types'
export default [
    {
        category: "外观",
        color: {
            type: propsTypes.color,
            label: "颜色",
            value: "",
        },
        bkType: {
            label: '背景类型',
            type: propsTypes.eumn,
            value: '',
            options: [
                {
                    label: '没有渐变',
                    value: 0,
                    active: true
                },
                {
                    label: '线性渐变',
                    value: 1,
                    active: false
                }, {
                    label: '发散渐变',
                    value: 2,
                    active: false
                },
            ]
        },
        background: {
            type: propsTypes.color,
            label: "背景颜色",
            value: "",
        },

        gradientFromColor: {
            label: '背景渐变起始颜色',
            type: propsTypes.color,
            value: ''
        },
        gradientToColor: {
            label: '背景渐变结束颜色',
            type: propsTypes.color,
            value: ''
        },
        gradientAngle: {
            label: '背景线性渐变角度',
            type: propsTypes.number,
            value: 0
        },
        gradientRadius: {
            label: '背景发散渐变半径',
            type: propsTypes.number,
            value: 0
        },
        shadowColor: {
            type: propsTypes.color,
            label: '阴影颜色',
            value: ''
        },
        shadowBlur: {
            type: propsTypes.number,
            label: '阴影模糊度',
            value: 0
        },
        shadowOffsetX: {
            type: propsTypes.number,
            label: '阴影偏移X',
            value: 0
        },
        shadowOffsetY: {
            type: propsTypes.number,
            label: '阴影偏移Y',
            value: 0
        },
        strokeType: {
            label: '线条颜色类型',
            type: propsTypes.eumn,
            value: '',
            options: [
                {
                    label: '没有渐变',
                    value: 0,
                    active: true
                },
                {
                    label: '线性渐变',
                    value: 1,
                    active: false
                }, {
                    label: '发散渐变',
                    value: 2,
                    active: false
                },
            ]
        },
        lineGradientFromColor: {
            label: '线条起始颜色',
            type: propsTypes.color,
            value: '',
        },
        lineGradientToColor: {
            label: '线条终止颜色',
            type: propsTypes.color,
            value: '',
        },
        lineGradientAngle: {
            label: '线条渐变角度',
            type: propsTypes.number,
            value: 0,
        },
        lineWidth: {
            type: propsTypes.number,
            label: "线条宽度",
            value: 0,
        },
        globalAlpha: {
            type: propsTypes.number,
            label: "透明度",
            value: 1,
            desc: '数值从0到1之间'
        },
        paddingTop: {
            type: propsTypes.number,
            label: '上边距',
            value: 0
        },
        paddingBottom: {
            type: propsTypes.number,
            label: '下边距',
            value: 0
        },
        paddingLeft: {
            type: propsTypes.number,
            label: '左边距',
            value: 0
        },
        paddingRight: {
            type: propsTypes.number,
            label: '右边距',
            value: 0
        },
        progress: {
            type: propsTypes.number,
            label: '进度',
            value: 0,
            desc: '数值从0到1之间'
        },
        progressColor: {
            type: propsTypes.color,
            label: '进度颜色',
            value: ''
        },
        verticalProgress: {
            type: propsTypes.switch,
            label: '垂直进度条',
            value: false
        },
        visible: {
            type: propsTypes.switch,
            label: '显示/隐藏',
            value: true
        },
        flipX: {
            type: propsTypes.switch,
            label: '水平翻转',
            value: false
        },
        flipY: {
            type: propsTypes.switch,
            label: '垂直翻转',
            value: false
        },
        borderRadius: {
            type: propsTypes.number,
            label: '圆角',
            value: 0
        },
        disableAnchor: {
            type: propsTypes.switch,
            label: '关闭锚点',
            value: false
        },
        hoverColor: {
            type: propsTypes.color,
            label: '鼠标经过颜色',
            value: ''
        },
        hoverBackground: {
            type: propsTypes.color,
            label: '鼠标经过背景颜色',
            value: ''
        },
        strokeImage: {
            type: propsTypes.string,
            label: '线条填充图片',
            value: ''
        },
        borderWidth: {
            type: propsTypes.number,
            label: '线边框宽度',
            value: 0
        },
        borderColor: {
            type: propsTypes.color,
            label: '连线边框颜色',
            value: ''
        },
        input: {
            type: propsTypes.switch,
            label: '点击显示输入框',
            value: false
        },
        locked: {
            type: propsTypes.eumn,
            label: '锁定',
            value: 0,
            options: [
                {
                    label: '无',
                    value: 0,
                    active: true
                },
                {
                    label: '禁止编辑',
                    value: 1,
                    active: false
                },
                {
                    label: '禁止移动',
                    value: 2,
                    active: false
                },
                {
                    label: '禁止编辑和移动',
                    value: 10,
                    active: false
                },
            ]
        },
        fromArrow: {
            type: propsTypes.eumn,
            label: "连线开始的箭头",
            value: "",
            options: [
                {
                    label: '无',
                    value: '',
                    active: true
                },
                {
                    label: '实心三角形',
                    value: 'triangleSolid',
                    active: true
                },
                {
                    label: '三角形',
                    value: 'triangle',
                    active: false
                }, {
                    label: '圆形',
                    value: 'circle',
                    active: false
                }, {
                    label: '实心圆形',
                    value: 'circleSolid',
                    active: false
                }, {
                    label: '实心钻石',
                    value: 'diamondSolid',
                    active: false
                }, {
                    label: '钻石形状',
                    value: 'diamond',
                    active: false
                }, {
                    label: '线',
                    value: 'line',
                    active: false
                },
                {
                    label: '向上线条',
                    value: 'lineUp',
                    active: false
                }, {
                    label: '向下线条',
                    value: 'lineDown',
                    active: false
                }
            ],
        },
        toArrow: {
            type: propsTypes.eumn,
            label: "连线结束的箭头",
            value: "",
            options: [
                {
                    label: '无',
                    value: '',
                    active: true
                }, {
                    label: '实心三角形',
                    value: 'triangleSolid',
                    active: false
                },
                {
                    label: '三角形',
                    value: 'triangle',
                    active: false
                }, {
                    label: '圆形',
                    value: 'circle',
                    active: false
                }, {
                    label: '实心圆形',
                    value: 'circleSolid',
                    active: false
                }, {
                    label: '实心钻石',
                    value: 'diamondSolid',
                    active: false
                }, {
                    label: '钻石形状',
                    value: 'diamond',
                    active: false
                }, {
                    label: '线',
                    value: 'line',
                    active: false
                },
                {
                    label: '向上线条',
                    value: 'lineUp',
                    active: false
                }, {
                    label: '向下线条',
                    value: 'lineDown',
                    active: false
                }]
        },
        lineCap: {
            label: '线两端的形状',
            type: propsTypes.eumn,
            value: '',
            options: [
                {
                    label: '圆形',
                    value: 'round',
                    active: true
                }, {
                    label: '平直',
                    value: 'butt',
                    active: false
                }, {
                    label: '正方形',
                    value: 'square',
                    active: false
                }
            ]
        },
        lineJoin: {
            label: '线段交汇形状',
            type: propsTypes.eumn,
            value: '',
            options: [
                {
                    label: '圆形',
                    value: 'round',
                    active: true
                }, {
                    label: '斜角',
                    value: 'bevel',
                    active: false
                }, {
                    label: '尖角',
                    value: 'miter',
                    active: false
                }
            ]
        },

        zIndex: {
            label: '层级',
            value: 0,
            type: propsTypes.number
        },
        ratio: {
            label: '等比例缩放',
            value: true,
            type: propsTypes.switch
        },
        rotate: {
            label: '旋转',
            value: 0,
            type: propsTypes.number
        },
   
    }, {
        category: '文字',
        text: {
            label: '文本内容',
            type: propsTypes.string,
            value: ''
        },
        textColor: {
            type: propsTypes.color,
            label: "文字颜色",
            value: "",
        },
        fontSize: {
            type: propsTypes.number,
            label: "字体大小",
            value: 12,
        },
        lineHeight: {
            type: propsTypes.number,
            label: "文本行高",
            value: 1,
        },
        fontWeight: {
            type: propsTypes.number,
            label: "字体粗细",
            value: 400,
        },
        textAlign: {
            type: propsTypes.eumn,
            label: "文字对齐",
            value: "",
            options: [{ label: 'left', value: 'left', active: false }, { label: 'center', value: 'center', active: true }, { label: 'right', value: 'right', active: false }],
        },
        textBaseline: {
            type: propsTypes.eumn,
            label: "文字基线",
            value: "",
            options: [{ label: 'top', value: 'top', active: false }, { label: 'middle', value: 'middle', active: true }, { label: 'bottom', value: 'bottom', active: false }],
        },
        textBackground: {
            type: propsTypes.color,
            label: "文字背景颜色",
            value: "",
        },
        textFlip: {
            label: '文字镜像',
            type: propsTypes.switch,
            value: false
        },
        ellipsis: {
            label: '超出示省略号',
            type: propsTypes.switch,
            value: true
        },

        title: {
            label: '鼠标经过文字提示',
            type: propsTypes.string,
            value: ''
        }
    },{
        category: '图片',
        image: {
            type: propsTypes.string,
            label: '图片地址',
            value: '',
            desc: '可以是网络地址或base64'
        },
        imageRatio: {
            type: propsTypes.switch,
            label: '是否保持长宽比例',
            value: true,
        },
        backgroundImage: {
            type: propsTypes.string,
            label: '背景图片地址',
            value: '',
            desc: '可以是网络地址或base64'
        },
        imageRadius: {
            type: propsTypes.number,
            label: '图片圆角',
            value: 0
        }

    }
]